<div class="header">
  <!-- Desktop screen -->
  @if(!isMobile()) {
  <img
    (click)="onLogoClick()"
    class="header__logo logo"
    [src]="logoUrl"
    alt="Meplis"
  />

  @if(isAuthenticated()){
  <app-search-input
    class="header__search-container"
    [placeholder]="'SEARCH_ALL_YOU_NEED'"
    (searchInputChange)="onSearchInputChange($event)"
  ></app-search-input>

  <div class="header__menu-list">
    @for (item of menuItems; track item) {
<div
      [ngClass]="{
        'header__menu-item--active': isMenuActive(item)
      }"
      (click)="selectMenu(item)"
     
      class="header__menu-item"
    >
      <fa-icon class="header__menu-icon" [icon]="item.iconClass | faIconName"></fa-icon>
      <span class="header__menu-title">{{ item.keyTitle | translate }}</span>
    </div>
}

    <app-hub-menu
      [showExploreMeplis]="false"
      [showGoHome]="false"
      [triggerStyle]="'general'"
    ></app-hub-menu>
  </div>

  <div class="header__right-actions">
    <button
      [matMenuTriggerFor]="menuNewItems"
      [disabled]="!userInstance?.token"
      class="btn btn--sm btn--icon-text"
    >
      <span>+ {{ 'CREATE_GLOBAL' | translate }}</span>
    </button>

    <app-chat-menu></app-chat-menu>

    <div class="header__notification-container">
      <app-notification-menu></app-notification-menu>
    </div>

    <app-profile-avatar
      [profileId]="profileId"
      [disableMenu]="true"
      [matMenuTriggerFor]="profileWidget"
    ></app-profile-avatar>
  </div>
  }@else {
  <div class="header__right-actions">
    <button (click)="goToLogin()" class="btn btn--outline btn--sm">
      <span>{{ 'LOGIN' | translate }}</span>
    </button>
    <button (click)="goToSignUp()" class="btn btn--sm">
      <span>{{ 'SIGN_UP' | translate }}</span>
    </button>
  </div>
  } }@else {
  <!-- Mobile screen -->
  <div
    class="header-mobile"
    [ngClass]="{ 'header-mobile--search-opened': mobileSearchOpened }"
  >
    <div class="header-mobile__header">
      <div (click)="onLogoClick()" class="header-mobile__lef-side">
        <img class="header-mobile__logo logo" [src]="logoUrl" alt="Meplis" />
      </div>

      @if(isAuthenticated()){
      <div class="header-mobile__right-side">
        @if (!mobileSearchOpened) {
<button
          (click)="toogleSearchMobile()"
          class="btn btn--sm btn--icon btn--no-bg"
         
          [attr.aria-label]="'ARIA.OPEN_SEARCH' | translate"
        >
          <fa-icon [icon]="['fasr', 'magnifying-glass']" class="header__search-icon"
           
          ></fa-icon>
        </button>
}
        <div class="header-mobile__search-container">
          <input
            [(ngModel)]="searchFilter"
            (keyup.enter)="search()"
            [placeholder]="'SEARCH_ALL_YOU_NEED' | translate"
            class="header-mobile__search-title field__input field__input--sm"
          />
          <fa-icon [icon]="['fasr', 'magnifying-glass']" class="header-mobile__search-icon"
            (click)="search(); toogleSearchMobile()"
           
            role="button"
            tabindex="0"
            [attr.aria-label]="'ARIA.SEARCH' | translate"
          ></fa-icon>
        </div>

        @if (!mobileSearchOpened) {
<app-notification-menu
         
        ></app-notification-menu>
}

        <app-profile-avatar
          [profileId]="profileId"
          [disableMenu]="true"
          [matMenuTriggerFor]="profileWidget"
        ></app-profile-avatar>
      </div>
      }@else {
      <div class="header-mobile__right-side">
        <button (click)="goToLogin()" class="btn btn--outline btn--sm">
          <span>{{ 'LOGIN' | translate }}</span>
        </button>
        <button (click)="goToSignUp()" class="btn btn--sm">
          <span>{{ 'SIGN_UP' | translate }}</span>
        </button>
      </div>
      }
    </div>

    @if(isAuthenticated()){
    <div
      class="mobile-menu__menu"
      [ngClass]="{ 'mobile-menu__menu--show': mobileMenuOpened }"
    >
      <button
        class="mobile-menu__close"
        (click)="toogleMobileMenu()"
        [attr.aria-label]="'ARIA.CLOSE_MENU' | translate"
      >
        <fa-icon [icon]="['fass', 'xmark']"></fa-icon>
      </button>
      <div class="mobile-menu__container">
        <div class="profile card">
          <div class="profile__top">
            <img
              class="profile__top-image"
              [src]="profileBackgroundImageUrl"
              alt=""
            />
            <div class="profile__overlay"></div>
            <app-profile-avatar
              [profileId]="profileId"
              [disableMenu]="true"
              class="profile__avatar"
            ></app-profile-avatar>
          </div>

          <div class="profile__info">
            <h4>{{ userInstance?.name }}</h4>
            @if(userInstance?.specialty?.name) {
            <span>
              {{ userInstance?.specialty?.name || 'No specialty selected' }}
            </span>
            }
          </div>
          <!-- <div class="profile__gamification">
            <div class="profile__gamification-bar-container">
              <span class="profile__gamification-bar-title">
                {{ 'Level 3' }}</span
              >
              <div class="profile__gamification-bar">
                <div
                  [ngStyle]="{ width: '30%' }"
                  class="profile__gamification-load"
                ></div>
              </div>
            </div>
            <div class="profile__gamification-items">
              <div class="profile__gamification-item">
                <div class="profile__gamification-icon-container">
                  <fa-icon [icon]="['fass', 'bolt']" class="profile__gamification-icon profile__gamification-icon--yellow"
                   
                  ></fa-icon>
                </div>
                <div class="profile__gamification-item-info">
                  <span class="profile__gamification-item-number">
                    {{ '3' }}
                  </span>
                  <span class="profile__gamification-item-description">
                    {{ 'Days streaks' }}</span
                  >
                </div>
              </div>

              <div class="profile__gamification-item">
                <div class="profile__gamification-icon-container">
                  <fa-icon [icon]="['fass', 'users']" class="profile__gamification-icon profile__gamification-icon--blue"
                   
                  ></fa-icon>
                </div>
                <div class="profile__gamification-item-info">
                  <span class="profile__gamification-item-number">
                    {{ '8' }}</span
                  >
                  <span class="profile__gamification-item-description">{{
                    'Collaboration'
                  }}</span>
                </div>
              </div>
            </div>
          </div> -->
        </div>

        <div class="separator"></div>

        <div class="mobile-menu__menu-list">
          <app-hub-menu
            [showExploreMeplis]="false"
            [showGoHome]="false"
            [triggerStyle]="'mobile'"
            (hubSelected)="toogleMobileMenu()"
          ></app-hub-menu>

          @for (item of menuItems; track item) {
<div
            [ngClass]="{
              'header__menu-item--active': isMenuActive(item)
            }"
            (click)="selectMenu(item)"
           
            class="mobile-menu__menu-item"
          >
            <fa-icon class="header__menu-icon" [icon]="item.iconClass | faIconName"></fa-icon>
            <span class="mobile-menu__menu-title">{{
              item.keyTitle | translate
            }}</span>
          </div>
}
        </div>

        <div class="mobile-menu__right-actions">
          <button
            [matMenuTriggerFor]="menuNewItems"
            [disabled]="!userInstance?.token"
            class="btn btn--sm btn--icon-text"
          >
            <span>+ {{ 'CREATE_GLOBAL' | translate }}</span>
          </button>
        </div>
      </div>
    </div>

    <app-mobile-bottom-nav
      [items]="bottomNavItems"
      [currentRoute]="currentRoute"
      [chatUnreadCount]="chatUnreadCount"
      (itemSelected)="selectMenu($event)"
      (chatClicked)="onChatClick()"
      (menuClicked)="toogleMobileMenu()"
    ></app-mobile-bottom-nav>
    }
  </div>
  }

  <!-- shared menus — used by both desktop and mobile triggers -->
  <mat-menu #menuNewItems="matMenu">
    <button (click)="openCreateThreadModal()" mat-menu-item>
      {{ 'FEED.NEW_THREAD' | translate }}
    </button>
    <button (click)="openCreateGroupModal()" mat-menu-item>
      {{ 'FEED.NEW_GROUP' | translate }}
    </button>
    <button (click)="openCreateClinicalCaseModal()" mat-menu-item>
      {{ 'FEED.NEW_CLINICAL_CASE' | translate }}
    </button>
    @if(userInstance?.administrator) {
    <button (click)="openCreateWorkspace()" mat-menu-item>
      {{ 'HUBS.NEW' | translate }}
    </button>
    }
  </mat-menu>

  <mat-menu #profileWidget="matMenu">
    <app-profile-widget></app-profile-widget>
  </mat-menu>
</div>
